import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';

import { ButtonMode, ButtonSize, ButtonTheme, IconPosition } from '@fcom/ui-components';
import { CmsTarget } from '@fcom/core-api';

@Component({
  selector: 'fin-benefit-banner',
  templateUrl: './benefit-banner.component.html',
})
export class BenefitBannerComponent {
  readonly ButtonMode = ButtonMode;
  readonly ButtonSize = ButtonSize;
  readonly ButtonTheme = ButtonTheme;
  readonly IconPosition = IconPosition;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input() invertedColors = false;
  @Input() title: string;
  @Input() buttons: CmsTarget[] = [];

  constructor(private router: Router) {}

  navigateTo(url: string): void {
    this.router.navigateByUrl(url);
  }
}
